// extracted by mini-css-extract-plugin
export default {"title":"AddInventoryItem_title__hlSDt","inputform":"AddInventoryItem_inputform__MC9q3"};